import React from 'react';

import { useTranslation } from "react-i18next";

import m1 from '../img/marquee/m1.png';
import m2 from '../img/marquee/m2.png';
import m3 from '../img/marquee/m3.png';
import m4 from '../img/marquee/m4.png';
import m5 from '../img/marquee/m5.png';
import m6 from '../img/marquee/m6.png';
import m7 from '../img/marquee/m7.png';
import m8 from '../img/marquee/m8.png';
import m9 from '../img/marquee/m9.png';

import Marquee from 'react-fast-marquee';

function Footer() {

  const { t } = useTranslation();

  return (
    <div className='bg-[#131313] z-10 relative h-[1000px] overflow-hidden mt-[80px] xl:mt-[120px] rounded-t-[40px] xl:rounded-t-[60px]'>
      <div className='flex flex-col items-center'>
        <p className='text-center text-[24px] xl:text-[40px] manrope font-[500] text-white leading-[1.2] mt-[80px]'>{t('footer.1')}</p>\
        <Marquee autoFill className='mt-[60px] xl:mt-[100px]'>
          <img src={m1} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m2} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m3} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m4} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m5} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m6} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m7} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m8} className='px-[20px] xl:px-[50px]' alt="" />
          <img src={m9} className='px-[20px] xl:px-[50px]' alt="" />
        </Marquee>
      </div>
      <div className='mt-[80px] xl:mt-[140px] h-px w-full bg-[#A3E9E6] max-w-[1220px] mx-[20px] xl:mx-auto'></div>
      <div className='grid grid-cols-1 xl:grid-cols-3 gap-y-[20px] xl:gap-y-[35px] max-w-[1220px] mx-[20px] xl:mx-auto mt-[20px] xl:mt-[40px]'>
        <div>
          <p className='text-[10px] xl:text-[12px] roboto font-[500] text-[#FFFFFFB2]'>{t('footer.2')}</p>
          <p className='text-[10px] xl:text-[12px] roboto font-[300] text-[#FFFFFFB2] xl:max-w-[310px] mt-[12px]'>{t('footer.3')}</p>
        </div>
        <div>
          <p className='text-[10px] xl:text-[12px] roboto font-[500] text-[#FFFFFFB2]'>{t('footer.4')}</p>
          <p className='text-[10px] xl:text-[12px] roboto font-[300] text-[#FFFFFFB2] xl:max-w-[362px] mt-[12px]'>{t('footer.5')}</p>
        </div>
        <div>
          <p className='text-[10px] xl:text-[12px] roboto font-[500] text-[#FFFFFFB2]'>{t('footer.6')}</p>
          <p className='text-[10px] xl:text-[12px] roboto font-[300] text-[#FFFFFFB2] xl:max-w-[393px] mt-[12px]'>{t('footer.7')}</p>
        </div>
        <div>
          <p className='text-[10px] xl:text-[12px] roboto font-[500] text-[#FFFFFFB2]'>{t('footer.8')}</p>
          <p className='text-[10px] xl:text-[12px] roboto font-[300] text-[#FFFFFFB2] xl:max-w-[334px] mt-[12px]'>{t('footer.9')}</p>
        </div>
        <div>
          <p className='text-[10px] xl:text-[12px] roboto font-[500] text-[#FFFFFFB2]'>{t('footer.10')}</p>
          <p className='text-[10px] xl:text-[12px] roboto font-[300] text-[#FFFFFFB2] xl:max-w-[374px] mt-[12px]'>{t('footer.11')}</p>
        </div>
        <div>
          <div>
            <p className='text-[10px] xl:text-[14px] roboto font-[500] text-[#FFFFFFB2]'>Address: Stettbachstrasse 7, 8600 Dübendorf, Switzerland</p>
            <p className='text-[10px] xl:text-[14px] roboto font-[500] text-[#FFFFFFB2]'>Phone:  +441887480765</p>
          </div>
          <div className='grid grid-cols-3 mt-[20px] gap-y-[6px]'>
            <a href="/docs/client.pdf"><p className='text-[10px] text-center xl:text-[12px] hover:font-[500] transition-all text-[#A3E9E6] roboto'>{t('footer.12')}</p></a>
            <a href="/docs/privacy.pdf"><p className='text-[10px] text-center xl:text-[12px] hover:font-[500] transition-all text-[#A3E9E6] roboto'>{t('footer.13')}</p></a>
            <a href="/docs/conflict.pdf"><p className='text-[10px] text-center xl:text-[12px] hover:font-[500] transition-all text-[#A3E9E6] roboto'>{t('footer.14')}</p></a>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default Footer;